document.addEventListener('DOMContentLoaded', function () {
    const section   = document.querySelector('.offers-section');
    if (!section) return;

    const filtersBox = section.querySelector('[data-offers-filters]');
    const resetBtn   = section.querySelector('[data-offers-reset]');
    const content    = section.querySelector('[data-offers-content]');
    const checks     = Array.from(filtersBox.querySelectorAll('.custom-checkbox__field'));

    function selectedIds() {
        return new Set(checks.filter(cb => cb.checked).map(cb => cb.value));
    }

    function reorderGroups() {
        const sel = selectedIds();
        const groups = Array.from(content.querySelectorAll('.offers-section__inner'));

        groups.sort((a, b) => {
            const aSel = sel.has(a.dataset.termId);
            const bSel = sel.has(b.dataset.termId);
            if (aSel !== bSel) return aSel ? -1 : 1;

            const aOrd = parseInt(a.dataset.order || '0', 10);
            const bOrd = parseInt(b.dataset.order || '0', 10);
            return aOrd - bOrd;
        });


        const frag = document.createDocumentFragment();
        groups.forEach(g => frag.appendChild(g));
        content.appendChild(frag);
    }


    function updateResetState() {
        const any = checks.some(cb => cb.checked);
        if (any) {
            resetBtn.classList.remove('is-disabled');
            resetBtn.removeAttribute('disabled');
            resetBtn.style.pointerEvents = '';
        } else {
            resetBtn.classList.add('is-disabled');
            resetBtn.setAttribute('disabled', 'disabled');
            resetBtn.style.pointerEvents = 'none';
        }
    }

    checks.forEach(cb => cb.addEventListener('change', () => {
        reorderGroups();
        updateResetState();
    }));

    resetBtn.addEventListener('click', () => {
        checks.forEach(cb => cb.checked = false);
        reorderGroups();
        updateResetState();
    });

    reorderGroups();
    updateResetState();
});
